// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"view-image"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 3H21V21H3V3Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M6 6H18V18H6V6Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 3H21V21H3V3Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7 13L9 11L15.5 17.5M6 6H18V18H6V6ZM15 9.99996C15 10.5522 14.5523 11 14 11C13.4477 11 13 10.5522 13 9.99996C13 9.44768 13.4477 8.99996 14 8.99996C14.5523 8.99996 15 9.44768 15 9.99996Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ViewImageIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'view-image',
    ref,
    icon: element,
  },
));

ViewImageIcon.displayName = 'ViewImageIcon';

export default ViewImageIcon;
